import ReactEcharts from "echarts-for-react";
import { useRef } from "react";

export default function HourlyAlarm({ title, id }) {
  const echarts_react_1 = useRef();
  const labelOption = {
    show: true,
    rotate: 90,
    align: 'left',
    verticalAlign: 'middle',
    position: 'top',
    formatter: '{c}',

    fontSize: 12,
    rich: {
      name: {}
    }
  };
  const option = {
    title: {
      text: '',
      subtext: ''
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['Mains Fail', 'DC Low', 'Site Down']
    },
    toolbox: {
      show: false,
      feature: {
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ['line', 'bar'] },
        restore: { show: true },
        saveAsImage: { show: true }
      }
    },
    calculable: true,
    xAxis: [
      {
        type: 'category',
        data: [
          '00:00',
          '01:00',
          '02:00',
          '03:00',
          '04:00',
          '05:00',
          '06:00',
          '07:00',
          '08:00',
          '09:00',
          '10:00',
          '11:00'
        ]
      }
    ],
    yAxis: [
      {
        name: 'Number Of Alarm',
        nameLocation: 'middle',
        nameGap: 60,
        nameTextStyle: {
          fontWeight: 'bold',
          color: '#000000'
        },
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#000'
          }
        },
        splitLine: {
          lineStyle: {
            color: '#ddd'
          }
        },
        axisLabel: {
          formatter: '{value}'
        },
        axisPointer: {
          snap: true
        }
      }
    ],
    series: [
      {
        name: 'Mains Fail',
        type: 'line',
        smooth: true,
        data: [
          2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
        ],
        label: labelOption
      },
      {
        name: 'DC Low',
        type: 'line',
        smooth: true,
        data: [
          2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
        ],
        label: labelOption
      },
      {
        name: 'Site Down',
        type: 'line',
        smooth: true,
        data: [2, 5, 9, 6, 68, 77, 0, 18, 48, 18, 6, 2],
        label: labelOption
      }
    ]
  };

  return (
    <>
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>{title}</h5>
          <div className="d-flex gap-2">
            <input type="text" className="form-control form-control-sm" placeholder="search by site id.." />
            <select className="form-select form-select-sm" >
              <option>All Tenant</option>
              <option>BL</option>
              <option>Robi</option>
              <option>GP</option>
            </select>
            <select className="form-select form-select-sm" >
              <option>Last 24hours</option>
              <option>Date</option>
            </select>
            <div class="dropdown">
              <button type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown">
                Export
              </button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#">CSV</a></li>
                <li><a class="dropdown-item" href="#">XLSX</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="card-body p-0 m-0">
          <ReactEcharts ref={echarts_react_1} style={{ height: "300px" }} option={option} />

        </div>
      </div>
    </>
  );
}